export const ActionablesDto = {
  AllocateRentingRequest: "AllocateRentingRequest",
  ActivateRentingRequest: "ActivateRentingRequest",
  TerminateRentingRequest: "TerminateRentingRequest",
  ApproveListingRequest: "ApproveListingRequest",
  TerminateListingRequest: "TerminateListingRequest",
  MakePaymentRequest: "MakePaymentRequest",
  SwapParkingBayRequest: "SwapParkingBayRequest",
};

export const ActionablesTitle = {
  Approve: "Approve",
  Reject: "Reject",
  Allocate: "Allocate",
  Deallocate: "Deallocate",
  Activate: "Activate",
  Freeze: "Freeze",
  Unfreeze: "Unfreeze",
  Swap: "Swap",
  ApproveAndTerminate: "Approve & Terminate",
  Terminate: "Terminate",
  ForceTerminate: "Force Terminate",
  Cancel: "Cancel",
  CancelTerminate: "Cancel Terminate",
};

export const ListingStatus = {
  INITIAL: "INITIAL",
  PROCESSING: "PROCESSING",
  VACANT: "VACANT",
  OCCUPIED: "OCCUPIED",
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  TERMINATING: "TERMINATING",
  TERMINATING_PROCESSING: "TERMINATING_PROCESSING",
  TERMINATION_APPROVED: "TERMINATION_APPROVED",
  TERMINATED: "TERMINATED",
  REJECTED: "REJECTED",
  ALLOCATED: "ALLOCATED",
};

export const RentingStatus = {
  INITIAL: "INITIAL",
  PROCESSING: "PROCESSING",
  BOOKED: "BOOKED",
  PRE_ALLOCATED: "PRE_ALLOCATED",
  ALLOCATED: "ALLOCATED",
  PAYING: "PAYING",
  PAID: "PAID",
  PRE_ACTIVE: "PRE_ACTIVE",
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  OWNER_TERMINATING: "OWNER_TERMINATING",
  TERMINATING_PROCESSING: "TERMINATING_PROCESSING",
  TERMINATION_APPROVED: "TERMINATION_APPROVED",
  TERMINATING: "TERMINATING",
  TERMINATED: "TERMINATED",
  CANCELLED: "CANCELLED",
};

export const SeasonPassStatus = {
  TERMINATION_APPROVED: "TERMINATION_APPROVED",
  INITIAL: "INITIAL",
  PROCESSING: "PROCESSING",
  BOOKED: "BOOKED",
  REFUND_PROCESSING: "REFUND_PROCESSING",
  PAID: "PAID",
  PRE_ACTIVE: "PRE_ACTIVE",
  AWAITING_VEHICLE_APPROVAL: "AWAITING_VEHICLE_APPROVAL",
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
  TERMINATING_PROCESSING: "TERMINATING_PROCESSING",
  TERMINATING: "TERMINATING",
  TERMINATED: "TERMINATED",
  CANCELLED: "CANCELLED",
  ARCHIVED: "ARCHIVED",
};

export const BusinessType = {
  BUSINESS_TO_BUSINESS: "BUSINESS_TO_BUSINESS",
  BUSINESS_TO_CONSUMER: "BUSINESS_TO_CONSUMER",
};

export const NearbyType = {
  NONE: "NONE",
  WORK_HERE: "WORK_HERE",
  STAY_HERE: "STAY_HERE",
  STAY_OR_WORK_NEARBY: "STAY_OR_WORK_NEARBY",
};

export const Currency = {
  MY: "MYR",
  HK: "HKD",
  SG: "SGD",
};

export const InsuranceStatus = {
  SUBSCRIBED: "SUBSCRIBED",
  TERMINATING: "TERMINATING",
  UNSUBSCRIBED: "UNSUBSCRIBED",
};

export const OperationStatus = {
  SOURCING: "SOURCING",
  CLOSING: "CLOSING",
  PENDING_CARD_COLLECTION: "PENDING_CARD_COLLECTION",
  DONE: "DONE",
};

export const SubscriptionStatus = {
  NEW: "NEW",
  ACTIVE: "ACTIVE",
  TERMINATING: "TERMINATING",
  TERMINATED: "TERMINATED",
};

export const SubscriptionChargeStatus = {
  PENDING: "PENDING",
  PAID: "PAID",
  RETRYING: "RETRYING",
  FAILED: "FAILED",
  PAUSE_CHARGE: "PAUSE_CHARGE",
};

export const SearchType = {
  MASTERLIST: "MASTERLIST",
  ENQUIRY: "ENQUIRY",
  TERMINATION: "TERMINATION",
  INVENTORY: "INVENTORY",
  DEFAULT: "DEFAULT",
};

export const BankName = {
  CITIBANK: "Citibank",
  MAYBANK: "Maybank",
  MAYBANK_ISLAMIC: "Maybank Islamic",
  PUBLIC_BANK: "Public Bank",
  PUBLIC_BANK_ISLAMIC: "Public Bank Islamic",
  CIMB: "CIMB",
  CIMB_ISLAMIC: "CIMB Islamic",
  RHB_BANK: "RHB Bank",
  RHB_BANK_ISLAMIC: "RHB Islamic",
  ALLIANCE_BANK: "Alliance Bank",
  ALLIANCE_ISLAMIC: "Alliance Islamic",
  AMBANK: "AmBank",
  AMBANK_ISLAMIC: "AmBank Islamic",
  AFFIN_BANK: "Affin Bank",
  AFFIN_ISLAMIC: "Affin Islamic",
  HONG_LEONG_BANK: "Hong Leong Bank",
  STANDARD_CHARTERED: "Standard Chartered",
  HSBC: "HSBC",
  HSBC_AMANAH: "HSBC Amanah",
  UOB: "UOB",
  OCBC: "OCBC",
  BANK_ISLAM: "Bank Islam",
  BANK_NEGARA: "Bank Negara",
  BANK_MUAMALAT: "Bank Muamalat",
  BANK_RAKYAT: "Bank Rakyat",
  AL_RAJHI: "Al Rajhi",
  BANK_SIMPANAN_NASIONAL: "Bank Simpanan Nasional",
  AMINVESTMENT_BANK: "AmInvestment Bank",
  AMINVESTMENT_BANK_SPI: "AmInvestment Bank SPI",
  AFFIN_HWANG_INVESTMENT: "Affin Hwang Investment",
  AGROBANK_SPI: "Agrobank SPI",
  GX_BANK: "GX Bank",
  BANK_OF_CHINA: "Bank of China",
  INDUSTRIAL_COMMERCIAL_BANK_OF_CHINA:
    "Industrial and Commercial Bank of China",
  JPMORGAN_CHASE_BANK: "JPMorgan Chase Bank",
  UNDEFINED: "Undefined",
};

export const LeasePeriodType = {
  ANNUALLY: "P12M",
  HALF_YEARLY: "P6M",
  QUARTERLY: "P3M",
  MONTHLY: "P1M",
};

export const ContactCountryCode = [
  { code: "MY", label: "Malaysia", phone: "+60" },
  { code: "HK", label: "Hong Kong", phone: "+852" },
  { code: "SG", label: "Singapore", phone: "+65" },
  { code: "JP", label: "Japan", phone: "+81" },
  { code: "GB", label: "United Kingdom", phone: "+44" },
  { code: "ID", label: "Indonesia", phone: "+62" },
];

export const RefereeCommissionOn = {
  monthlySellPrice: "Monthly Sell Price",
  monthlyBuyPrice: "Monthly Buy Price",
  insuranceSellPrice: "Insurance Sell Price",
};

export const RefereeCommissionType = {
  oneOff: "One-off",
};

// Cooling off is a date rather than a status, so a payable claim is not always ready to pay
export const ReferralPayoutStatus = {
  payable: "Ready to pay",
  nonPayable: "Cancelled",
  paid: "Paid",
};

export const ReferralSourceType = {
  motorInsurance: "Motor Insurance",
  rentParking: "Rent a Parking",
};

export const ReferralRewardType = {
  creditToWallet: "Credit To Wallet",
};

export const PromoServiceType = {
  UNSPECIFIC: "Unspecific (All Services)",
  PARKING: "Parking",
  ADMINISTRATION: "Administration Fee",
  DEPOSIT: "Deposit",
  DELIVERY_SERVICE: "Delivery Service",
  INSURANCE_SUBSCRIPTION: "Insurance Subscription",
  RENTAL_SUBSCRIPTION: "Rental Subscription",
  MOTOR_INSURANCE: "Motor Insurance",
  PARKING_SEASON_PASS: "Parking Season Pass",
};

export const PromoConditionKey = {
  PLATFORM: "Platform",
  PARKING_AREA_ID: "Parking Area ID",
};

export const PromoConditionOperator = {
  EQUALS: "Equals",
  NOT_EQUALS: "Not Equals",
};

export const RefundReason = {
  REQUESTED_BY_CUSTOMER: "Requested by customer",
  DUPLICATE: "Duplicate",
  FRAUDULENT: "Fraudulent",
};

export const RefundStatus = {
  PENDING: "PENDING",
  SUCCEEDED: "SUCCEEDED",
  FAILED: "FAILED",
};

export const RefundSource = {
  STRIPE: "STRIPE",
  WALLET_BALANCE: "WALLET_BALANCE",
};
